import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { useLocation } from "react-router-dom";
import Toastiy from "../../../components/universal/Toastiy";

import {
  addJournalNoteAction,
  addJournalNoteItemAction,
  deleteJournalNoteAction,
  deleteJournalNoteItemAction,
  readJournalAction,
  readLanguageAction,
  saveBGJournalAction,
  saveJournalAction,
  saveJournalBannerAction,
  translateLanguageAction,
  updateBGJournalAction,
  updateJournalAction,
  updateJournalBannerAction,
  updateJournalNoteItemAction,
  uploadAssestsAction,
  uploadAssestsV2Action,
} from "../../../store/Languages/LanguageAction";
import { setShowNavigationAlertAction } from "../../../store/GlobalLoader/GlobalLoaderAction";
import { sendCustomNotificationAction } from "../../../store/Notifications/NotificationAction";
import {
  getSpeakersListAction,
  getJournalCategoriesAction,
  updateJournalLanguageAction,
  saveJournalLanguageAction,
  saveJournalLanguageNotesAction,
  saveJournalLanguageNoteItemsAction,
  updateJournalLanguageNoteItemsAction,
  updateJournalLanguageNotesAction,
  getBibleSearch,
  setAllJournalsAction,
} from "../../../store/Bible/BibleAction";
import { JOURNAL_NOTE_ITEM_TYPES } from "../../../constants/Common";
import { toast } from "react-toastify";
import ConfirmToast from "../../../components/universal/ConfirmToast";

export const JournalsHookNew = (setLoading, journal_id, setJournalId,rowData) => {
       if(rowData){
    journal_id=rowData._id;
   }
     const dispatch = useDispatch();
  const navigate = useNavigate();

  const { allJournals = [] } = useSelector((state) => state.journals || {});


  const [speakers, setSpeakers] = useState([]);
  const [activeSpeakerDetails, setActiveSpeakerDetails] = useState({});
  const [activeCategoryDetails, setActiveCategoryDetails] = useState({});
  const [journalCategoriesList, setJournalCategoriesList] = useState([]);
  const [forceEditorUpdate, setForceEditorUpdate] = useState(false);
  const [journalStats, setJournalStats] = useState({});
  const [journalPublishLoading, setJournalPublishLoading] = useState(false);
  const [isAddVerseToastOpen, setAddVerseToastOpen] = useState(false);
  const [searchTxt, setSearchTxt] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [fullscreenVideo, setFullscreenVideo] = useState(null);
const [churchId,setChurchId]=useState();
const location=useLocation();
  useEffect(() => {
    return () => setShowNavigationAlert(false);
  }, []);

  const setShowNavigationAlert = (value) => {
    dispatch(setShowNavigationAlertAction(value));
  };

  //notes delete
  const handleDeleteNotes = ({ noteObjId, notesIndex }) => {
        const options = {
      customUI: ({ onClose }) => {
        return (
          <ConfirmToast
            title="Are you sure?"
            message="You want to delete this note?"
            onClose={() => onClose()}
            onSuccess={() => {
              dispatch(
                deleteJournalNoteAction({
                  apiPayloadRequest: {
                    _id: journal_id,
                    noteObjId: noteObjId,
                  },
                  callback: (res) => {
                    // if (res?.type === 1) {dispatch(
                    dispatch(
                      updateJournalAction({
                        apiPayloadRequest: {
                          _id: journal_id,
                          publish: false,
                        },
                        callback: (res) => {},
                      }),
                    );

                    const updatedCurriculumValues =
                      structuredClone(journalValues);
                    updatedCurriculumValues.publish = false;
                    updatedCurriculumValues?.notes?.splice(notesIndex, 1);
                    setJournalValues(updatedCurriculumValues);
                    setShowNotesBox(false);
                    setCurrNotes(initialNotesState);
                    Toastiy("Notes Deleted Successfully!", 1);
                  },
                }),
              );
              onClose();
            }}
          />
        );
      },
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
      overlayClassName: "!bg-gray-500 !bg-opacity-75 !z-[1000]",
    };

    confirmAlert(options);
  };

  //lesson trailer video library selection
  const handleNotesLibraryVideoSelection = (details) => {
    const updatedJournals = structuredClone(journalValues);
    updatedJournals.notes[currNotesIndex].lesson_trailers[0].bg_asset_url = [
      {
        type_of_url: "0",
        url_link: details?.urls?.find((d) => d?.type_of_url === "0")?.url_link,
      },
      {
        type_of_url: "1",
        url_link: details?.urls?.find((d) => d?.type_of_url === "1")?.url_link,
      },
      {
        type_of_url: "2",
        url_link: details?.urls?.find((d) => d?.type_of_url === "2")?.url_link,
      },
    ];
    setJournalValues(updatedJournals);
    setShowNavigationAlert(true);
  };

  const inititialUrlState = [
    {
      type_of_url: "0",
      url_link: "",
    },
    {
      type_of_url: "1",
      url_link: "",
    },
    {
      type_of_url: "2",
      url_link: "",
    },
  ];

  const initialNotesState = { text: "", noteitems: [] };

  const initialJournalState = {
    journal_title: "",
    journal_description: "",
    speakerObjId: "",
    categoryObjId: "",
    bg_Images: [
      {
        type_of_url: "0",
        url_link: "",
      },
      {
        type_of_url: "1",
        url_link: "",
      },
      {
        type_of_url: "2",
        url_link: "",
      },
    ],
    banner_Images: [
      {
        type_of_url: "0",
        url_link: "",
      },
      {
        type_of_url: "1",
        url_link: "",
      },
      {
        type_of_url: "2",
        url_link: "",
      },
    ],
    notes: [],
  };

  const initialJournalErrors = {
    journal_title: true,
    journal_description: true,
    speakerObjId: true,
    categoryObjId: true,
    bg_Images: [
      {
        type_of_url: "0",
        url_link: true,
      },
      {
        type_of_url: "1",
        url_link: true,
      },
      {
        type_of_url: "2",
        url_link: true,
      },
    ],
    banner_Images: [
      {
        type_of_url: "0",
        url_link: true,
      },
      {
        type_of_url: "1",
        url_link: true,
      },
      {
        type_of_url: "2",
        url_link: true,
      },
    ],
  };

  const [languagemeta, setLanguagemeta] = useState();
  const [isLanguageSave, setIsLanguageSave] = useState(true);
  const [readLanguageData, setReadLanguageData] = useState([]);
  const [activeTab, setActiveTab] = useState("en");
  const [activeLanguageDetails, setActiveLanguageDetails] = useState({
    language_code: "en",
    language_name: "English",
  });
  const [journalValues, setJournalValues] = useState(initialJournalState);
  const [currJournalValues, setCurrJournalValues] =
    useState(initialJournalState);
  const [journalsErrors, setJournalsErrors] = useState(initialJournalErrors);

  const [showJournalsErrors, setShowJournalsErrors] = useState(false);
  const [showNotesErrors, setShowNotesErrors] = useState(false);

  const [showJournalBox, setShowJournalBox] = useState(false);
  const [showNotesBox, setShowNotesBox] = useState(false);

  const [currNotes, setCurrNotes] = useState(initialNotesState);

  const [currNotesIndex, setCurrNotesIndex] = useState(0);

  const [isNotesEdit, setIsNotesEdit] = useState(false);

  const [showPreview, setShowPreview] = useState(false);

  const keysArray = Object.keys(inititialUrlState);


  const addNewNotes = () => {
    setShowNotesBox(true);
  };

  const cancelNotes = () => {
    setShowNotesErrors(false);
    if (!isNotesEdit) {
      const updatedNotes = [
        ...journalValues.notes.filter((_, idx) => idx !== currNotesIndex),
      ];
      setJournalValues((prev) => ({
        ...prev,
        notes: [...updatedNotes],
      }));
    } else {
      const prevNotes = [...journalValues.notes];

      prevNotes[currNotesIndex] = currNotes;

      setJournalValues((prev) => ({
        ...prev,
        notes: prevNotes,
      }));
    }
  };

  const cancelJournal = () => {
    setShowJournalBox(false);
  };

  const saveNotes = () => {
    setShowNotesErrors(false);
    const updatedCurrNotes = structuredClone(currNotes);
    if (updatedCurrNotes?.text?.length > 0) {
      updatedCurrNotes.noteitems = [
        ...(updatedCurrNotes?.noteitems ?? []),
        {
          notes: updatedCurrNotes?.text,
          type_of_notes: JOURNAL_NOTE_ITEM_TYPES.TEXT,
        },
      ];
    }
        updatedCurrNotes.lastUpdated = new Date().toISOString();
    if (!isNotesEdit) {
      if (journal_id !== undefined) {
        dispatch(
          addJournalNoteAction({
            apiPayloadRequest: {
              _id: journal_id,
              notesTitle: " ",
            },
            callback: (response) => {
              if (response?.type === 1) {
                const promiseArray = [];
                updatedCurrNotes?.noteitems?.map((item, index) => {
                  promiseArray.push(
                    new Promise((res, rej) => {
                      const payload = {
                        _id: journal_id,
                        noteObjId: response?.noteObjId,
                        type_of_notes: item?.type_of_notes,
                        url_link: item?.url_link ?? " ",
                        notes: item?.notes ?? "",
                        thumbnail: item?.thumbnail ?? "",
                        duration: item?.duration ?? "",
                        sortOrder: `${index + 1}`,
                      };

                      if (
                        item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.VERSE
                      ) {
                        payload.verse_start = item?.verse_start;
                        payload.verse_end = item?.verse_end;
                        payload.bookname = item?.bookname;
                        payload.bookid = item?.bookid;
                        payload.chapterid = item?.chapterid;
                      }
                      dispatch(
                        addJournalNoteItemAction({
                          apiPayloadRequest: payload,
                          callback: (resp) => {
                            res();
                          },
                        }),
                      );
                    }),
                  );
                });

                promiseArray.push(
                  new Promise((resolve) => {
                    dispatch(
                      updateJournalAction({
                        apiPayloadRequest: {
                          _id: journal_id,
                          publish: false,
                        },
                        callback: (res) => {
                          resolve();
                        },
                      }),
                    );
                  }),
                );

                Promise.allSettled(promiseArray).then(() => {
                  Toastiy("Notes Draft Saved Successfully!", 1);
                  getJournalDetails();
                });

                setShowNotesBox(false);
                setCurrNotesIndex(journalValues?.notes?.length);
              } else {
                Toastiy("Failed to Save Notes");
              }
            },
          }),
        );
      } else {
        setJournalValues((prev) => ({
          ...prev,
          notes: [...(prev.notes ?? []), updatedCurrNotes],
        }));
        setShowNotesBox(false);
        setCurrNotesIndex(journalValues?.notes?.length);
        setShowNavigationAlert(true);
      }
    } else {
      if (journal_id !== undefined) {
        const promiseArray = [];
        updatedCurrNotes?.noteitems?.map((item, index) => {
          promiseArray.push(
            new Promise((res, rej) => {
              if (item?.notesItemObjId) {
                if (
                  ![JOURNAL_NOTE_ITEM_TYPES.TEXT].includes(item?.type_of_notes)
                ) {
                  res();
                } else {
                  dispatch(
                    updateJournalNoteItemAction({
                      apiPayloadRequest: {
                        _id: journal_id,
                        noteObjId: updatedCurrNotes?.noteObjId,
                        notesItemObjId: item?.notesItemObjId,
                        type_of_notes: item?.type_of_notes,
                        url_link: item?.url_link ?? " ",
                        notes: item?.notes ?? "",
                        thumbnail: item?.thumbnail ?? "",
                        sortOrder: `${index + 1}`,
                      },
                      callback: (resp) => {
                        res();
                      },
                    }),
                  );
                }
              } else {
                const payload = {
                  _id: journal_id,
                  noteObjId: updatedCurrNotes?.noteObjId,
                  type_of_notes: item?.type_of_notes,
                  url_link: item?.url_link ?? " ",
                  notes: item?.notes ?? "",
                  thumbnail: item?.thumbnail ?? "",
                  duration: item?.duration ?? "",
                  sortOrder: `${index + 1}`,
                };

                if (item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.VERSE) {
                  payload.verse_start = item?.verse_start;
                  payload.verse_end = item?.verse_end;
                  payload.bookname = item?.bookname;
                  payload.bookid = item?.bookid;
                  payload.chapterid = item?.chapterid;
                }
                dispatch(
                  addJournalNoteItemAction({
                    apiPayloadRequest: payload,
                    callback: (resp) => {
                      res();
                    },
                  }),
                );
              }
            }),
          );
        });

        promiseArray.push(
          new Promise((resolve) => {
            dispatch(
              updateJournalAction({
                apiPayloadRequest: {
                  _id: journal_id,
                  publish: false,
                },
                callback: (res) => {
                  resolve();
                },
              }),
            );
          }),
        );

        Promise.allSettled(promiseArray).then(() => {
          toast.success("Notes Updated Successfully!!");
          getJournalDetails();
        });

        setShowNotesBox(false);
      } else {
        setShowNotesBox(false);
        setShowNavigationAlert(true);
        setCurrNotesIndex(journalValues?.notes?.length);
      }
    }
  };

  const saveNotesLanguage = () => {
    setShowNotesErrors(false);
    const updatedCurrNotes = structuredClone(currNotes);

    const langdata = languagemeta?.find(
      (item) => item?.language_code === activeTab,
    );
    const data = langdata?.notes?.find(
      (item) => item?.noteObjId === updatedCurrNotes?.noteObjId,
    );

    updatedCurrNotes.lastUpdated = new Date().toISOString();

    if (!data?.noteObjId) {
      const promiseArray = [];
      promiseArray.push(
        new Promise((resolve, reject) => {
          dispatch(
            saveJournalLanguageNotesAction({
              apiPayloadRequest: {
                _id: journal_id,
                language_code: activeTab,
                notesTitle: updatedCurrNotes?.notesTitle,
                noteObjId: updatedCurrNotes?.noteObjId,
              },
              callback: (response) => {
                resolve();
                if (response?.data?.type === 1) {
                  Toastiy("Notes Draft Saved Successfully!", 1);
                  updatedCurrNotes?.noteitems?.map((item, index) => {
                    promiseArray.push(
                      new Promise((res, rej) => {
                        dispatch(
                          saveJournalLanguageNoteItemsAction({
                            apiPayloadRequest: {
                              _id: journal_id,
                              language_code: activeTab,
                              noteObjId: updatedCurrNotes?.noteObjId,
                              notesItemObjId: item?.notesItemObjId,
                              type_of_notes: item?.type_of_notes,
                              url_link: item?.url_link ?? " ",
                              notes: item?.notes ?? "",
                              thumbnail: item?.thumbnail ?? "",
                              duration: item?.duration ?? "",
                              sortOrder: `${index + 1}`,
                            },
                            callback: (resp) => {
                              res();
                            },
                          }),
                        );
                      }),
                    );
                  });

                  setShowNotesBox(false);
                  setCurrNotesIndex(journalValues?.notes?.length);
                } else {
                  Toastiy("Failed to Save Notes");
                }
              },
            }),
          );
        }),
      );

      Promise.allSettled(promiseArray).then(() => {
        getJournalDetails();
      });
    } else {
      const promiseArray = [];

      promiseArray.push(
        new Promise((resolve, reject) => {
          dispatch(
            updateJournalLanguageNotesAction({
              apiPayloadRequest: {
                _id: journal_id,
                language_code: activeTab,
                notesTitle: updatedCurrNotes?.notesTitle,
                noteObjId: updatedCurrNotes?.noteObjId,
              },
              callback: (response) => {
                resolve();
              },
            }),
          );
        }),
      );


      updatedCurrNotes?.noteitems?.map((item, index) => {
        promiseArray.push(
          new Promise((res, rej) => {
            if (data?.noteitems?.[index]?.notesItemObjId) {
              dispatch(
                updateJournalLanguageNoteItemsAction({
                  apiPayloadRequest: {
                    _id: journal_id,
                    language_code: activeTab,
                    noteObjId: updatedCurrNotes?.noteObjId,
                    type_of_notes: item?.type_of_notes,
                    notesItemObjId: item?.notesItemObjId,
                    url_link: item?.url_link ?? " ",
                    notes: item?.notes ?? "",
                    duration: item?.duration ?? "",
                    thumbnail: item?.thumbnail ?? "",
                    sortOrder: `${index + 1}`,
                  },
                  callback: (resp) => {
                    res();
                  },
                }),
              );
            } else {
              dispatch(
                saveJournalLanguageNoteItemsAction({
                  apiPayloadRequest: {
                    _id: journal_id,
                    language_code: activeTab,
                    noteObjId: updatedCurrNotes?.noteObjId,
                    notesItemObjId: item?.notesItemObjId,
                    type_of_notes: item?.type_of_notes,
                    url_link: item?.url_link ?? " ",
                    notes: item?.notes ?? "",
                    duration: item?.duration ?? "",
                    thumbnail: item?.thumbnail ?? "",
                    sortOrder: `${index + 1}`,
                  },
                  callback: (resp) => {
                    res();
                  },
                }),
              );
            }
          }),
        );
      });

      Promise.allSettled(promiseArray).then(() => {
        getJournalDetails();
      });

      setShowNotesBox(false);
    }
  };

  const handleClosePreview = () => {
    setShowPreview(false);
  };

  const handleOpenPreview = () => {
    setShowPreview(true);
  };

  //HandleChange
  const handleChangeId=(event)=>{
    const {name,value}=event.target;
    setChurchId(value);
  }
  const handleChange = (
    e,
    category,
    urlIndex,
    notesIndex,
    slideIndex,
    uploadProgressId = null,
  ) => {
    const { name, value, files } = e.target;

    setForceEditorUpdate(false);

    const updatedJournals = structuredClone(journalValues);
    const updatedJournalsErrors = { ...journalsErrors };

    switch (category) {
      case "journal":
        if (name === "bg_Images" || name === "banner_Images") {
          if (!updatedJournals[name] || updatedJournals[name]?.length === 0) {
            updatedJournals[name] = initialJournalState[name];
          }
          updatedJournals[name][urlIndex].url_link = value;
          if (name === "bg_Images" || name === "banner_Images")
            updatedJournalsErrors[name][urlIndex].url_link =
              value.length > 0 ? false : true;
        } else {
          updatedJournals[name] = value;
          updatedJournalsErrors[name] = value.length > 0 ? false : true;
        }
        break;
      case "journalFile":
        if (
          (name === "bg_Images" || name === "banner_Images") &&
          files.length > 0
        ) {
          setLoading(true);
          const formData = new FormData();
          formData.append("file", files[0]);

          dispatch(
            uploadAssestsV2Action({
              apiPayloadRequest: formData,
              uploadProgressId: uploadProgressId,
              callback: (res) => {
                if (res && res.url) {
                  if (
                    !updatedJournals[name] ||
                    updatedJournals[name]?.length === 0
                  ) {
                    updatedJournals[name] = initialJournalState[name];
                  }
                  updatedJournals[name][urlIndex].url_link = res.url;
                  updatedJournalsErrors[name][urlIndex].url_link =
                    res.url.length > 0 ? false : true;

                  setJournalValues(updatedJournals);
                  setJournalsErrors(updatedJournalsErrors);
                }
                setLoading(false);
              },
            }),
          );
        }
        break;
      case "notes":
        if (name === "lesson_tumbnail_urls") {
          if (
            !updatedJournals?.notes?.[notesIndex]?.lesson_tumbnail_urls ||
            updatedJournals?.notes?.[notesIndex]?.lesson_tumbnail_urls
              ?.length === 0
          ) {
            updatedJournals.notes[notesIndex]["lesson_tumbnail_urls"] =
              initialNotesState?.lesson_tumbnail_urls;
          }
          updatedJournals.notes[notesIndex][name][urlIndex].url_link = value;
        } else {
          updatedJournals.notes[notesIndex][name] = value;
        }
        break;
      case "notesFile":
        if (
          name === "notes_video_urls" ||
          name === "notes_audio_urls" ||
          name === "notes_image_urls"
        ) {
          setLoading(true);
          const formData = new FormData();
          formData.append("file", files[0]);
          dispatch(
            uploadAssestsV2Action({
              apiPayloadRequest: formData,
              uploadProgressId: uploadProgressId,
              callback: (res) => {
                if (res && res.url) {
                  if (
                    updatedJournals.notes?.[notesIndex]?.[name]?.length === 0
                  ) {
                    updatedJournals.notes[notesIndex][name] =
                      initialNotesState[name];
                  }
                  updatedJournals.notes[notesIndex][name] = {
                    url_link: res.url,
                  };

                  setJournalValues(updatedJournals);
                }
                setLoading(false);
              },
            }),
          );
        }
        break;
      default:
        break;
    }

    setJournalsErrors(updatedJournalsErrors);
            setJournalValues(updatedJournals);
    setShowNavigationAlert(true);
  };

  const isValidJournalTitle = (title) => {
    const regex = /^[A-Za-z0-9\s\-:',.()&]+$/;
    return regex.test(title);
  };

  const saveJournals = ({hideUI,onClose,reloadData,setReloadData,church}) => {
        setShowJournalsErrors(false);

    // Allow: letters, numbers, spaces, and common punctuation . , ! ? : ; ' " ( ) - _ & / @ #
    // Disallow: emojis and other special characters
    const allowedRegex = /^[\w\s.,!?':;"()_&/@#-]+$/u;

    const containsInvalidChars = (str) => {
      if (!str) return false;
      // Remove allowed characters, if anything remains, it's invalid
      return !allowedRegex.test(str);
    };

    // Emoji regex (matches most emoji code points)
    const emojiRegex = /[\p{Emoji_Presentation}\u200d\uFE0F]/u;

    if (!journalValues?.journal_title?.trim()) {
      Toastiy("Add a journal title to proceed further.");
      return;
    }
    if (!journalValues?.journal_description?.trim()) {
      Toastiy("Add a journal description to proceed further.");
      return;
    }
    if (
      !isValidJournalTitle(journalValues?.journal_title) ||
      !isValidJournalTitle(journalValues?.journal_description)
    ) {
      Toastiy(
        "Journal title contains invalid characters. Please use only letters, numbers, spaces, and basic punctuation (like '-', ':', '&').",
      );
      return;
    }

    if (
      allJournals?.some(
        (d) =>
          d?.journal_title === journalValues?.journal_title &&
          d?._id !== journal_id,
      )
    ) {
      toast.error("Journal Already exists with the same name!!");
      return;
    }

    if (journal_id !== undefined) {
      if (
        journalValues?.journal_title !== currJournalValues?.journal_title ||
        journalValues?.journal_description !==
          currJournalValues?.journal_description ||
        journalValues?.speakerObjId !== currJournalValues?.speakerObjId ||
        journalValues?.categoryObjId !== currJournalValues?.categoryObjId
      ) {
        setLoading(true);
        dispatch(
          updateJournalAction({
            apiPayloadRequest: {
              _id: journal_id,
              journal_title: journalValues?.journal_title,
              journal_description: journalValues?.journal_description,
              speakerObjId: journalValues?.speakerObjId,
              categoryObjId: journalValues?.categoryObjId,
              publish: false,
            },
            callback: (res) => {
              Toastiy("Journal Draft Updated Successfully!", 1);

              setCurrJournalValues((prev) => ({
                ...prev,
                _id: journal_id,
                journal_title: journalValues?.journal_title,
                journal_description: journalValues?.journal_description,
                speakerObjId: journalValues?.speakerObjId,
                categoryObjId: journalValues?.categoryObjId,
                publish: false,
              }));
              setLoading(false);
              setShowJournalBox(false);
              setShowNavigationAlert(false);
              onClose();
              setReloadData(!reloadData)
            },
          }),
        );
      }

      journalValues?.bg_Images?.map((item, index) => {
        if (
          journalValues?.bg_Images?.[index]?.url_link &&
          !currJournalValues?.bg_Images?.[index]?.url_link
        ) {
          setTimeout(() => {
            dispatch(
              saveBGJournalAction({
                apiPayloadRequest: {
                  _id: journal_id,
                  type_of_url: parseInt(
                    journalValues?.bg_Images?.[index]?.type_of_url,
                  ),
                  url_link: journalValues?.bg_Images?.[index]?.url_link,
                },
                callback: (res) => {
                  // if (res?.type === 1) {
                  Toastiy("Journal BG Updated Successfully!", 1);
                  setCurrJournalValues((prev) => ({
                    ...prev,
                    bg_Images: (prev?.bg_Images ?? []).map((item, i) => ({
                      type_of_url: journalValues?.bg_Images?.[i]?.type_of_url,
                      url_link: journalValues?.bg_Images?.[i]?.url_link,
                    })),
                  }));
                  setShowNavigationAlert(false);
                  // } else {
                  //   Toastiy("Failed to Save Journal BG");
                  // }
                },
              }),
            );
          }, index * 500);
        } else if (
          journalValues?.bg_Images?.[index]?.url_link &&
          journalValues?.bg_Images?.[index]?.url_link !==
            currJournalValues?.bg_Images?.[index]?.url_link
        ) {
          setTimeout(() => {
            dispatch(
              updateBGJournalAction({
                apiPayloadRequest: {
                  _id: journal_id,
                  type_of_url: parseInt(
                    journalValues?.bg_Images?.[index]?.type_of_url,
                  ),
                  url_link: journalValues?.bg_Images?.[index]?.url_link,
                },
                callback: (res) => {
                  // if (res?.type === 1) {
                  Toastiy("Journal BG Updated Successfully!", 1);
                  setCurrJournalValues((prev) => ({
                    ...prev,
                    bg_Images: (prev?.bg_Images ?? []).map((item, i) => ({
                      type_of_url: journalValues?.bg_Images?.[i]?.type_of_url,
                      url_link: journalValues?.bg_Images?.[i]?.url_link,
                    })),
                  }));
                  setShowNavigationAlert(false);
                  // } else {
                  //   Toastiy("Failed to Save Journal BG");
                  // }
                },
              }),
            );
          }, index * 500);
        }
      });
      journalValues?.banner_Images?.map((item, index) => {
        if (
          journalValues?.banner_Images?.[index]?.url_link &&
          !currJournalValues?.banner_Images?.[index]?.url_link
        ) {
          setTimeout(() => {
            dispatch(
              saveJournalBannerAction({
                apiPayloadRequest: {
                  _id: journal_id,
                  type_of_url: parseInt(
                    journalValues?.banner_Images?.[index]?.type_of_url,
                  ),
                  url_link: journalValues?.banner_Images?.[index]?.url_link,
                },
                callback: (res) => {
                  // if (res?.type === 1) {
                  Toastiy("Journal Banner Updated Successfully!", 1);
                  setCurrJournalValues((prev) => ({
                    ...prev,
                    banner_Images: (prev?.banner_Images ?? []).map(
                      (item, i) => ({
                        type_of_url:
                          journalValues?.banner_Images?.[i]?.type_of_url,
                        url_link: journalValues?.banner_Images?.[i]?.url_link,
                      }),
                    ),
                  }));
                  setShowNavigationAlert(false);
                  // } else {
                  //   Toastiy("Failed to Save Journal BG");
                  // }
                },
              }),
            );
          }, index * 500);
        } else if (
          journalValues?.banner_Images?.[index]?.url_link &&
          journalValues?.banner_Images?.[index]?.url_link !==
            currJournalValues?.banner_Images?.[index]?.url_link
        ) {
          setTimeout(() => {
            dispatch(
              updateJournalBannerAction({
                apiPayloadRequest: {
                  _id: journal_id,
                  type_of_url: parseInt(
                    journalValues?.banner_Images?.[index]?.type_of_url,
                  ),
                  url_link: journalValues?.banner_Images?.[index]?.url_link,
                },
                callback: (res) => {
                  // if (res?.type === 1) {
                  Toastiy("Journal Banner Updated Successfully!", 1);
                  setCurrJournalValues((prev) => ({
                    ...prev,
                    banner_Images: (prev?.banner_Images ?? []).map(
                      (item, i) => ({
                        type_of_url:
                          journalValues?.banner_Images?.[i]?.type_of_url,
                        url_link: journalValues?.banner_Images?.[i]?.url_link,
                      }),
                    ),
                  }));
                  setShowNavigationAlert(false);
                  // } else {
                  //   Toastiy("Failed to Save Journal BG");
                  // }
                },
              }),
            );
          }, index * 500);
        }
      });
    } else {
      setLoading(true);
              dispatch(
        saveJournalAction({
          apiPayloadRequest: {
            public: true,
            journal_title: journalValues?.journal_title,
            journal_description: journalValues?.journal_description,
            speakerObjId: journalValues?.speakerObjId,
            categoryObjId: journalValues?.categoryObjId,
            ...(location.pathname.includes("addMinistryField")
            ? { ministriesObjId: church?._id }
            : location.pathname.includes("addChannelField")
            ? { channelObjId: church?._id }
            : { churchObjid: church?._id }),
            publish: false,
          },
          callback: async (response) => {
            await saveJournalBg(response);
            await saveJournalBanner(response);
            setCurrJournalValues((prev) => ({
              ...prev,
              _id: response?.data[0]?._id,
              journal_title: journalValues?.journal_title,
              journal_description: journalValues?.journal_description,
              bg_Images: journalValues?.bg_Images,
              banner_Images: journalValues?.banner_Images,
              speakerObjId: journalValues?.speakerObjId,
              categoryObjId: journalValues?.categoryObjId,
              publish: false,
            }));
            setJournalId(response?.data[0]?._id);
            Toastiy("Journals Draft Saved Successfully!", 1);
            setTimeout(() => {
                if (hideUI) {
                  onClose();
                  setReloadData(!reloadData);
                } else {
                  navigate("/journals/add", {
                    state: { _id: response?.data[0]?._id },
                  });
                }
              }, 500);

            setLoading(false);
            setShowJournalBox(false);
            setShowNavigationAlert(false);
          },
        }),
      );
    }
  };

  const saveJournalsLanguage = () => {
    setShowJournalsErrors(false);

    const data = languagemeta?.find(
      (item) => item?.language_code === activeTab,
    );

    if (data?.journal_title) {
      if (
        journalValues?.journal_title !== currJournalValues?.journal_title ||
        journalValues?.journal_description !==
          currJournalValues?.journal_description
      ) {
        setLoading(true);
        dispatch(
          updateJournalLanguageAction({
            apiPayloadRequest: {
              _id: journal_id,
              language_code: activeTab,
              journal_title: journalValues?.journal_title,
              journal_description: journalValues?.journal_description,
            },
            callback: (response) => {
              Toastiy("Journal Draft Updated Successfully!", 1);
              setLoading(false);
              setShowJournalBox(false);
              setShowNavigationAlert(false);
              getJournalDetails();
            },
          }),
        );
      }
    } else {
      setLoading(true);
      dispatch(
        saveJournalLanguageAction({
          apiPayloadRequest: {
            _id: journal_id,
            language_code: activeTab,
            journal_title: journalValues?.journal_title,
            journal_description: journalValues?.journal_description,
          },
          callback: async (response) => {
            Toastiy("Journals Draft Updated Successfully!", 1);
            setLoading(false);
            setShowJournalBox(false);
            setShowNavigationAlert(false);
            getJournalDetails();
          },
        }),
      );
    }
  };


  const saveJournalBg = async (journalResponse) => {
    // if (journalResponse?.type === 1) {
    const id = journalResponse?.data[0]?._id;

    keysArray.map((item, index) => {
      setTimeout(
        () => {
          dispatch(
            saveBGJournalAction({
              apiPayloadRequest: {
                _id: id,
                type_of_url: parseInt(
                  journalValues.bg_Images[item].type_of_url,
                ),
                url_link: journalValues.bg_Images[item].url_link,
              },
              callback: (res) => {
                // if (res?.type !== 1) {
                // Toastiy("Failed to Save Journals BG");
                // } else {
                setShowNavigationAlert(false);
                // }
              },
            }),
          );
        },
        500 * (index + 1),
      );
    });
    // }
  };

  const reconstructJournalFromString = (journal) => {
    if (!journal) return null;

    const [journal_title, journal_description] = journal.split("///");

    const journalObject = {
      journal_title,
      journal_description,
    };

    const updatedJournalValues = structuredClone(journalValues);

    updatedJournalValues.journal_title = journalObject?.journal_title || "";
    updatedJournalValues.journal_description =
      journalObject?.journal_description || "";

    return updatedJournalValues;
  };

  const convertJournalToString = (journalObject) => {
    let journal = `${journalObject?.journal_title}///${journalObject?.journal_description}`;

    return journal;
  };

  const updateJournalsWithTranslation = () => {
    const combinedText = convertJournalToString(journalValues);

    if (activeTab.length > 0) {
      dispatch(
        translateLanguageAction({
          apiPayloadRequest: {
            targetcode: activeTab,
            translatetext: combinedText,
          },
          callback: (res) => {
            if (res?.type === 1) {
              const restructedData = reconstructJournalFromString(res?.data);
              if (restructedData) {
                setJournalValues(restructedData);
                setShowNavigationAlert(true);
              }
            } else if (res?.type === 2) {
              Toastiy("Language Translation failed!!");
              Toastiy(res?.message);
            }
          },
        }),
      );
    }
  };

  const saveJournalBanner = async (journalResponse) => {
    // if (journalResponse?.type === 1) {
    const id = journalResponse?.data[0]?._id;

    keysArray.map((item, index) => {
      setTimeout(
        () => {
          dispatch(
            saveJournalBannerAction({
              apiPayloadRequest: {
                _id: id,
                type_of_url: parseInt(
                  journalValues?.banner_Images?.[item]?.type_of_url,
                ),
                url_link: journalValues?.banner_Images?.[item]?.url_link,
              },
              callback: (res) => {
                // if (res?.type !== 1) {
                // Toastiy("Failed to Save Journals BG");
                // } else {
                setShowNavigationAlert(false);
                // }
              },
            }),
          );
        },
        500 * (index + 1),
      );
    });
    // }
  };

  const validateNotesComplete = (lesson) => {
    if (!lesson?.lesson_description) {
      return false;
    } else if (!lesson?.lesson_title) {
      return false;
    } else if (lesson?.slides?.length - 1 <= 0) {
      return false;
    }
    for (let i = 0; i < lesson?.lesson_tumbnail_urls?.length; i++) {
      if (
        !lesson?.lesson_tumbnail_urls?.[i]?.type_of_url ||
        !lesson?.lesson_tumbnail_urls?.[i]?.url_link
      ) {
        return false;
      }
    }
    return true;
  };

  const validateLessonLanguageComplete = (lesson) => {
    if (!lesson?.lesson_description) {
      return false;
    } else if (!lesson?.lesson_title) {
      return false;
    } else if (lesson?.slides?.length - 1 <= 0) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (activeTab === "en") {
      const updatedJournalsErrors = {
        journal_title: journalValues?.journal_title?.length > 0 ? false : true,
        journal_description:
          journalValues?.journal_description?.length > 0 ? false : true,
        speakerObjId: journalValues?.speakerObjId?.length > 0 ? false : true,
        speakerObjId: journalValues?.categoryObjId?.length > 0 ? false : true,
        bg_Images: [
          {
            type_of_url: "0",
            url_link:
              journalValues?.bg_Images?.[0]?.url_link?.length > 0
                ? false
                : true,
          },
          {
            type_of_url: "1",
            url_link:
              journalValues?.bg_Images?.[1]?.url_link?.length > 0
                ? false
                : true,
          },
          {
            type_of_url: "2",
            url_link:
              journalValues?.bg_Images?.[2]?.url_link?.length > 0
                ? false
                : true,
          },
        ],
        banner_Images: [
          {
            type_of_url: "0",
            url_link:
              journalValues?.banner_Images?.[0]?.url_link?.length > 0
                ? false
                : true,
          },
          {
            type_of_url: "1",
            url_link:
              journalValues?.banner_Images?.[1]?.url_link?.length > 0
                ? false
                : true,
          },
          {
            type_of_url: "2",
            url_link:
              journalValues?.banner_Images?.[2]?.url_link?.length > 0
                ? false
                : true,
          },
        ],
      };

      setJournalsErrors(updatedJournalsErrors);
    }
  }, [journalValues, activeTab,rowData]);

  useEffect(() => {
    // if (activeTab === "en") {
    const updatedNotesErrors = {
      note_description:
        journalValues?.lessons?.[currNotesIndex]?.lesson_description?.length > 0
          ? false
          : true,
      lesson_tumbnail_urls: [
        {
          type_of_url: "0",
          url_link:
            journalValues?.lessons?.[currNotesIndex]?.lesson_tumbnail_urls?.[0]
              ?.url_link.length > 0
              ? false
              : true,
        },
        {
          type_of_url: "1",
          url_link:
            journalValues?.lessons?.[currNotesIndex]?.lesson_tumbnail_urls?.[1]
              ?.url_link.length > 0
              ? false
              : true,
        },
        {
          type_of_url: "2",
          url_link:
            journalValues?.lessons?.[currNotesIndex]?.lesson_tumbnail_urls?.[2]
              ?.url_link.length > 0
              ? false
              : true,
        },
      ],
    };
    // }
  }, [currNotesIndex, journalValues, activeTab,rowData]);

  useEffect(() => {
    if (activeTab === "en") {
      setJournalValues(currJournalValues);
    } else {
      const isPresent = languagemeta?.some(
        (item) => item?.language_code === activeTab,
      );
      if (isPresent) {
        const data = languagemeta?.filter(
          (item) => item?.language_code === activeTab,
        )[0];
        const updatedJournalValues = {
          journal_title:
            data?.journal_title || currJournalValues?.journal_title || "",
          journal_description:
            data?.journal_description ||
            currJournalValues?.journal_description ||
            "",
          speakerObjId:
            data?.speakerObjId || currJournalValues?.speakerObjId || "",
          categoryObjId:
            data?.categoryObjId || currJournalValues?.categoryObjId || "",
          bg_Images: [
            {
              type_of_url: "0",
              url_link:
                data?.bg_Images?.find((d) => d?.type_of_url === "0")
                  ?.url_link ||
                currJournalValues?.bg_Images?.find(
                  (d) => d?.type_of_url === "0",
                )?.url_link ||
                "",
            },
            {
              type_of_url: "1",
              url_link:
                data?.bg_Images?.find((d) => d?.type_of_url === "1")
                  ?.url_link ||
                currJournalValues?.bg_Images?.find(
                  (d) => d?.type_of_url === "1",
                )?.url_link ||
                "",
            },
            {
              type_of_url: "2",
              url_link:
                data?.bg_Images?.find((d) => d?.type_of_url === "2")
                  ?.url_link ||
                currJournalValues?.bg_Images?.find(
                  (d) => d?.type_of_url === "2",
                )?.url_link ||
                "",
            },
          ],
          banner_Images: [
            {
              type_of_url: "0",
              url_link:
                data?.banner_Images?.find((d) => d?.type_of_url === "0")
                  ?.url_link ||
                currJournalValues?.banner_Images?.find(
                  (d) => d?.type_of_url === "0",
                )?.url_link ||
                "",
            },
            {
              type_of_url: "1",
              url_link:
                data?.banner_Images?.find((d) => d?.type_of_url === "1")
                  ?.url_link ||
                currJournalValues?.banner_Images?.find(
                  (d) => d?.type_of_url === "1",
                )?.url_link ||
                "",
            },
            {
              type_of_url: "2",
              url_link:
                data?.banner_Images?.find((d) => d?.type_of_url === "2")
                  ?.url_link ||
                currJournalValues?.banner_Images?.find(
                  (d) => d?.type_of_url === "2",
                )?.url_link ||
                "",
            },
          ],
          notes: (currJournalValues?.notes ?? [])?.map((note, noteIndex) => ({
            ...note,
            notesTitle:
              data?.notes?.[noteIndex]?.notesTitle || note?.notesTitle,
            noteitems: (note.noteitems ?? [])?.map(
              (noteItem, noteItemIndex) => ({
                ...noteItem,
                notes:
                  data?.notes?.[noteIndex]?.noteitems?.[noteItemIndex]?.notes ||
                  noteItem?.notes,
              }),
            ),
          })),
        };
        setJournalValues(updatedJournalValues);
      } else {
        const updatedJournalValues = {
          journal_title: currJournalValues?.journal_title || "",
          journal_description: currJournalValues?.journal_description || "",
          speakerObjId: currJournalValues?.speakerObjId || "",
          categoryObjId: currJournalValues?.categoryObjId || "",
          bg_Images: [
            {
              type_of_url: "0",
              url_link:
                currJournalValues?.bg_Images?.find(
                  (d) => d?.type_of_url === "0",
                )?.url_link || "",
            },
            {
              type_of_url: "1",
              url_link:
                currJournalValues?.bg_Images?.find(
                  (d) => d?.type_of_url === "1",
                )?.url_link || "",
            },
            {
              type_of_url: "2",
              url_link:
                currJournalValues?.bg_Images?.find(
                  (d) => d?.type_of_url === "2",
                )?.url_link || "",
            },
          ],
          banner_Images: [
            {
              type_of_url: "0",
              url_link:
                currJournalValues?.banner_Images?.find(
                  (d) => d?.type_of_url === "0",
                )?.url_link || "",
            },
            {
              type_of_url: "1",
              url_link:
                currJournalValues?.banner_Images?.find(
                  (d) => d?.type_of_url === "1",
                )?.url_link || "",
            },
            {
              type_of_url: "2",
              url_link:
                currJournalValues?.banner_Images?.find(
                  (d) => d?.type_of_url === "2",
                )?.url_link || "",
            },
          ],
          notes: currJournalValues?.notes ?? [],
        };
        setJournalValues(updatedJournalValues);
      }
    }
  }, [activeTab, currJournalValues, languagemeta,rowData]);

  const fetchAllJournals = () => {
    dispatch(
      readJournalAction({
        apiPayloadRequest: {},
        callback: (data) => {
          dispatch(setAllJournalsAction(data?.data || []));
        },
      }),
    );
  };

  useEffect(() => {
    fetchAllJournals();
  }, [rowData]);

  const getJournalDetails = () => {
    setLoading(true);
    dispatch(
      readJournalAction({
        apiPayloadRequest: { _id: journal_id },
        callback: (res) => {
          if (res.type === 1) {
            const data = res?.data[0];
            setJournalStats({
              totalLikes: data?.totallikes ?? 0,
              totalViews: data?.curriculum_views ?? 0,
            });
            setLanguagemeta(data?.languagemetas);
            const updatedData = {
              ...data,
              notes: (data?.notes ?? [])?.filter((d) => !d?.expiryDate),
            };
            setJournalValues(updatedData);
            setCurrJournalValues(updatedData);
          }
          setLoading(false);
        },
      }),
    );
  };

  const getSpeakersList = () => {
    dispatch(
      getSpeakersListAction({
        apiPayloadRequest: {
          page: 1,
          limit: 1000,
        },
        callback: (res) => {
          if (res.type === 1) {
            setSpeakers(res?.data);
          }
        },
      }),
    );
  };

  const getJournalCategories = () => {
    dispatch(
      getJournalCategoriesAction({
        apiPayloadRequest: {
          page: 1,
          limit: 1000,
        },
        callback: (res) => {
          if (res.type === 1) {
            setJournalCategoriesList(res?.data);
          }
        },
      }),
    );
  };


  useEffect(() => {
    if (journal_id !== undefined) {
      getJournalDetails();
    }
  }, [journal_id,rowData]);

  useEffect(() => {
    getSpeakersList();
    getJournalCategories();
  }, [rowData]);

  useEffect(() => {
    if (journalValues?.speakerObjId && speakers?.length > 0 && activeTab) {
      const speakerDetails = speakers?.find(
        (d) => d?._id === journalValues?.speakerObjId,
      );
      let speakerLanguageDetails = speakerDetails;
      if (activeTab !== "en") {
        const languagemetadetails = speakerLanguageDetails?.languagemetas?.find(
          (d) => d?.language_code === activeTab,
        );
        speakerLanguageDetails = {
          ...speakerLanguageDetails,
          ...(languagemetadetails ?? {}),
        };
      }
      setActiveSpeakerDetails(speakerLanguageDetails ?? {});
    }
  }, [speakers, journalValues, activeTab],rowData);

  useEffect(() => {
    if (journalValues?.categoryObjId && journalCategoriesList?.length > 0) {
      const journalCategoryDetails = journalCategoriesList?.find(
        (d) => d?._id === journalValues?.categoryObjId,
      );
      let categoryLanguageDetails = journalCategoryDetails;
      if (activeTab !== "en") {
        const languagemetadetails =
          categoryLanguageDetails?.languagemetas?.find(
            (d) => d?.language_code === activeTab,
          );
        categoryLanguageDetails = {
          ...categoryLanguageDetails,
          ...(languagemetadetails ?? {}),
        };
      }
      setActiveCategoryDetails(categoryLanguageDetails ?? {});
    }
  }, [journalCategoriesList, journalValues,rowData]);

  const fetchAllLanguages = () => {
    dispatch(
      readLanguageAction({
        callback: (response) => {
          if (response?.type === 1) {
            setReadLanguageData(response?.data);
          }
        },
      }),
    );
  };

  useEffect(() => {
    fetchAllLanguages();
  }, [rowData]);

  const handleSendNotification = () => {
    dispatch(
      sendCustomNotificationAction({
        apiPayloadRequest: {
          _id: journal_id,
          type: "3",
        },
        callback: (res) => {
          if (res?.type === 1) {
            Toastiy("Notification Sent Successfully", 1);
          }
        },
      }),
    );
  };


  const deleteNoteItem = (index) => {
    const options = {
      customUI: ({ onClose }) => {
        return (
          <ConfirmToast
            title="Are you sure?"
            message="You want to delete this note item?"
            onClose={() => onClose()}
            onSuccess={() => {
              dispatch(
                updateJournalAction({
                  apiPayloadRequest: {
                    _id: journal_id,
                    publish: false,
                  },
                  callback: (res) => {
                    getJournalDetails();
                  },
                }),
              );

              dispatch(
                deleteJournalNoteItemAction({
                  apiPayloadRequest: {
                    _id: journal_id,
                    noteObjId: currNotes?.noteObjId,
                    notesItemObjId:
                      currNotes?.noteitems?.[index]?.notesItemObjId,
                  },
                  callback: (res) => {
                    Toastiy("Item Removed Successfully!", 1);
                  },
                }),
              );
              setCurrNotes((prev) => {
                prev = {
                  ...prev,
                  noteitems: prev?.noteitems?.filter((_, i) => i !== index),
                };
                return prev;
              });
              onClose();
            }}
          />
        );
      },
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
      overlayClassName: "!bg-gray-500 !bg-opacity-75 !z-[1000]",
    };

    confirmAlert(options);
  };

  const handleAddNoteText = () => {
    setCurrNotes((prev) => {
      prev = {
        ...prev,
        text: "",
        noteitems: [
          ...(prev?.noteitems ?? []),
          { notes: prev?.text, type_of_notes: JOURNAL_NOTE_ITEM_TYPES.TEXT },
        ],
      };
      setForceEditorUpdate(true);
      setTimeout(() => setForceEditorUpdate(false), 500);
      return prev;
    });
  };

  const handleAddNotesAsset = (
    notesIndex,
    type_of_notes,
    files,
    url = null,
    caption,
    thumbnail,
    duration,
  ) => {
    let index;
    setCurrNotes((prev) => {
      index = prev?.noteitems?.length ?? 0;
      if (prev?.text?.length > 0) {
        prev = {
          text: "",
          noteitems: [
            ...(prev?.noteitems ?? []),
            { notes: prev?.text, type_of_notes: JOURNAL_NOTE_ITEM_TYPES.TEXT },
          ],
        };
        setForceEditorUpdate(true);
        index = prev?.noteitems?.length ?? 0;
      }

      prev = {
        ...prev,
        noteitems: [
          ...(prev?.noteitems ?? []),
          {
            url_link: url ?? "",
            type_of_notes: type_of_notes,
            isMulti: Array.isArray(url),
            isLoading: url ? false : true,
            notes: caption ?? "",
            thumbnail: thumbnail ?? "",
            duration: duration ?? "",
          },
        ],
      };
      return prev;
    });

    const isMulti = files?.length > 1;

            const promiseArray = [];
    if (!url) {
      const formData = new FormData();
      formData.append("file", files?.[0]);
            dispatch(
        uploadAssestsAction({
          apiPayloadRequest: formData,
          callback: (res) => {
                        if (res && res?.url) {
              setCurrNotes((prev) => {
                                const updatedData = structuredClone(prev);
                updatedData.noteitems[index] = {
                  ...(updatedData?.noteitems?.[index] ?? {}),
                  url_link: res?.url,
                  isLoading: false,
                };
                return updatedData;
              });
            }
          },
        }),
      );
    }

    if (thumbnail && typeof thumbnail !== "string") {
      const formData = new FormData();
      formData.append("file", thumbnail);
      dispatch(
        uploadAssestsAction({
          apiPayloadRequest: formData,
          callback: (res) => {
                        if (res && res?.url) {
              setCurrNotes((prev) => {
                                const updatedData = structuredClone(prev);
                updatedData.noteitems[index] = {
                  ...(updatedData?.noteitems?.[index] ?? {}),
                  thumbnail: res?.url,
                  isLoading: false,
                };
                return updatedData;
              });
            }
          },
        }),
      );
    }
    if (typeof thumbnail === "string" && thumbnail?.includes("https")) {
      setCurrNotes((prev) => {
                const updatedData = structuredClone(prev);
        updatedData.noteitems[index] = {
          ...(updatedData?.noteitems?.[index] ?? {}),
          thumbnail: thumbnail,
          isLoading: false,
        };
        return updatedData;
      });
    }

    setTimeout(() => setForceEditorUpdate(false), 500);
  };

  const getAudioDuration = (file) => {
    return new Promise((resolve, reject) => {
      const audio = document.createElement("audio");
      audio.preload = "metadata";
      audio.src = URL.createObjectURL(file);
      audio.onloadedmetadata = () => {
        URL.revokeObjectURL(audio.src);
        resolve(audio.duration);
      };
      audio.onerror = (e) => {
        reject(e);
      };
    });
  };

  const handlePublishJournal = (publishType = true) => {
    setJournalPublishLoading(true);
    if (journal_id !== undefined) {
      dispatch(
        updateJournalAction({
          apiPayloadRequest: {
            _id: journal_id,
            publish: publishType,
          },
          callback: (res) => {
            // if (res?.type === 1) {
            if (publishType) {
              Toastiy("Journal Published Successfully!", 1);
              getJournalDetails();
              setShowNavigationAlert(false);
            } else {
              setJournalValues((prev) => ({
                ...prev,
                publish: publishType + "",
              }));
            }
            setJournalPublishLoading(false);
            // }
          },
        }),
      );
    }
  };

  // Translate notes and noteitems
  const updateNotesWithTranslation = () => {
    const NOTE_TRANSLATE_DELIM = "////";

    // Only include noteitems with type_of_notes "0" (TEXT)
    const textNoteItems = (currNotes.noteitems || []).filter(
      (item) => !!item.notes,
    );

    // Join note text and all text note item texts with delimiter
    const allTexts = [
      currNotes.text,
      ...textNoteItems.map((item) => item.notes ?? ""),
    ].join(NOTE_TRANSLATE_DELIM);

    dispatch(
      translateLanguageAction({
        apiPayloadRequest: {
          targetcode: activeTab,
          translatetext: allTexts,
        },
        callback: (res) => {
          if (res?.type === 1 && res?.data) {
            // Split translated string back into note and note items
            const translatedArr = res.data.split(NOTE_TRANSLATE_DELIM);
                        setCurrNotes((prev) => ({
              ...prev,
              notesTitle: translatedArr[0] ?? prev.text,
              noteitems: (prev.noteitems || []).map((item, idx) => {
                if (!!item.notes) {
                  // Find the index in textNoteItems
                  const textIdx = textNoteItems.findIndex(
                    (tItem) => tItem?.notesItemObjId === item?.notesItemObjId,
                  );
                  return {
                    ...item,
                    notes: translatedArr[textIdx + 1] ?? item.notes,
                  };
                }
                setForceEditorUpdate(true);
                setTimeout(() => setForceEditorUpdate(false), 500);
                return item;
              }),
            }));
          } else {
            Toastiy("Note translation failed!");
          }
        },
      }),
    );
  };

  const handleSearch = (search) => {
    setIsSearching(true);
    dispatch(
      getBibleSearch({
        apiPayloadRequest: {
          question: search,
        },
        callback: (res) => {
          setSearchResults(res?.data ?? []);
          setIsSearching(false);
        },
      }),
    );
  };

  const handleJournalModalClose = () => {
    setShowJournalBox(false);
    if (activeTab === "en") {
      setJournalValues((prev) => ({
        ...prev,
        journal_title: currJournalValues?.journal_title,
        journal_description: currJournalValues?.journal_description,
        speakerObjId: currJournalValues?.speakerObjId,
        categoryObjId: currJournalValues?.categoryObjId,
      }));
    } else {
      const data = languagemeta?.find(
        (item) => item?.language_code === activeTab,
      );

      if (data) {
        setJournalValues((prev) => ({
          ...prev,
          journal_title: data?.journal_title,
          journal_description: data?.journal_description,
          speakerObjId: data?.speakerObjId,
          categoryObjId: data?.categoryObjId,
        }));
      } else {
        setJournalValues((prev) => ({
          ...prev,
          journal_title: currJournalValues?.journal_title,
          journal_description: currJournalValues?.journal_description,
          speakerObjId: currJournalValues?.speakerObjId,
          categoryObjId: currJournalValues?.categoryObjId,
        }));
      }
    }
  };

  return {
    updateNotesWithTranslation,
    handleAddNoteText,
    handleAddNotesAsset,
    journalValues,
    currJournalValues,
    handleChange,
    handleChangeId,
    addNewNotes,
    currNotesIndex,
    setCurrNotes,
    currNotes,
    cancelNotes,
    saveNotes,
    setShowNotesBox,
    showNotesBox,
    setCurrNotesIndex,
    setIsNotesEdit,
    initialNotesState,
    showJournalBox,
    showPreview,
    handleClosePreview,
    handleOpenPreview,
    setShowJournalBox,
    saveJournals,
    journalsErrors,
    showJournalsErrors,
    showNotesErrors,
    setShowJournalsErrors,
    setShowNotesErrors,
    readLanguageData,
    setActiveTab,
    activeTab,
    setIsLanguageSave,
    languagemeta,
    cancelJournal,
    isNotesEdit,
    validateNotesComplete,
    validateLessonLanguageComplete,
    handleDeleteNotes,
    activeLanguageDetails,
    setActiveLanguageDetails,
    handleNotesLibraryVideoSelection,
    forceEditorUpdate,
    isLanguageSave,
    journalStats,
    handleSendNotification,
    journalPublishLoading,
    handlePublishJournal,
    deleteNoteItem,
    speakers,
    updateJournalsWithTranslation,
    journalCategoriesList,
    activeSpeakerDetails,
    activeCategoryDetails,
    saveJournalsLanguage,
    saveNotesLanguage,
    handleSearch,
    searchTxt,
    setSearchTxt,
    isAddVerseToastOpen,
    setAddVerseToastOpen,
    isSearching,
    searchResults,
    setForceEditorUpdate,
    fullscreenImage,
    setFullscreenImage,
    fullscreenVideo,
    setFullscreenVideo,
    getAudioDuration,
    handleJournalModalClose,
    setJournalStats,
    setLanguagemeta,
    setJournalValues,
    setCurrJournalValues
  };
};
